/**
 * FaceSwap 选项配置 - 国际化版本
 * 使用翻译键引用，支持多语言
 */

export const styleOptions = [
  {
    name: "aiWorkbench.faceSwap.categories.style",
    key: "style",
    children: [
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.shotType.label",
        key: "shot_type",
        options: [
          { key: "Portrait", label: "aiWorkbench.faceSwapeStyleOptions.style.shotType.options.portrait" },
          { key: "Head portrait", label: "aiWorkbench.faceSwapeStyleOptions.style.shotType.options.headPortrait" },
          { key: "Head and shoulders portrait", label: "aiWorkbench.faceSwapeStyleOptions.style.shotType.options.headAndShoulders" },
          { key: "Half-length portrait", label: "aiWorkbench.faceSwapeStyleOptions.style.shotType.options.halfLength" },
          { key: "Full-length portrait", label: "aiWorkbench.faceSwapeStyleOptions.style.shotType.options.fullLength" },
          { key: "Face", label: "aiWorkbench.faceSwapeStyleOptions.style.shotType.options.face" },
          { key: "Close-up", label: "aiWorkbench.faceSwapeStyleOptions.style.shotType.options.closeUp" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.imagingStyle.label",
        key: "imaging_style",
        options: [
          { key: "Standard mode", label: "aiWorkbench.faceSwapeStyleOptions.style.imagingStyle.options.standard" },
          { key: "High contrast mode", label: "aiWorkbench.faceSwapeStyleOptions.style.imagingStyle.options.highContrast" },
          { key: "Landscape mode", label: "aiWorkbench.faceSwapeStyleOptions.style.imagingStyle.options.landscape" },
          { key: "Portrait mode", label: "aiWorkbench.faceSwapeStyleOptions.style.imagingStyle.options.portrait" },
          { key: "Black and white mode", label: "aiWorkbench.faceSwapeStyleOptions.style.imagingStyle.options.blackAndWhite" },
          { key: "Clarity enhancement", label: "aiWorkbench.faceSwapeStyleOptions.style.imagingStyle.options.clarityEnhancement" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.artisticStyle.label",
        key: "artistic_style",
        options: [
          { key: "Realistic style", label: "aiWorkbench.faceSwapeStyleOptions.style.artisticStyle.options.realistic" },
          { key: "Illustration style", label: "aiWorkbench.faceSwapeStyleOptions.style.artisticStyle.options.illustration" },
          { key: "Cartoon style", label: "aiWorkbench.faceSwapeStyleOptions.style.artisticStyle.options.cartoon" },
          { key: "Watercolor style", label: "aiWorkbench.faceSwapeStyleOptions.style.artisticStyle.options.watercolor" },
          { key: "Vintage style", label: "aiWorkbench.faceSwapeStyleOptions.style.artisticStyle.options.vintage" },
          { key: "Steampunk style", label: "aiWorkbench.faceSwapeStyleOptions.style.artisticStyle.options.steampunk" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.artEffect.label",
        key: "art_effect",
        options: [
          { key: "Oil painting effect", label: "aiWorkbench.faceSwapeStyleOptions.style.artEffect.options.oilPainting" },
          { key: "Ink wash painting effect", label: "aiWorkbench.faceSwapeStyleOptions.style.artEffect.options.inkWash" },
          { key: "Sketch effect", label: "aiWorkbench.faceSwapeStyleOptions.style.artEffect.options.sketch" },
          { key: "Colored pencil effect", label: "aiWorkbench.faceSwapeStyleOptions.style.artEffect.options.coloredPencil" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.depthOfField.label",
        key: "depth_of_field",
        options: [
          { key: "Shallow depth of field", label: "aiWorkbench.faceSwapeStyleOptions.style.depthOfField.options.shallow" },
          { key: "Medium depth of field", label: "aiWorkbench.faceSwapeStyleOptions.style.depthOfField.options.medium" },
          { key: "Deep depth of field", label: "aiWorkbench.faceSwapeStyleOptions.style.depthOfField.options.deep" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.photoEffect.label",
        key: "photo_effect",
        options: [
          { key: "Aspect ratio crop (1:1, 16:9)", label: "aiWorkbench.faceSwapeStyleOptions.style.photoEffect.options.aspectRatioCrop" },
          { key: "Vintage style", label: "aiWorkbench.faceSwapeStyleOptions.style.photoEffect.options.vintage" },
          { key: "HDR (High Dynamic Range)", label: "aiWorkbench.faceSwapeStyleOptions.style.photoEffect.options.hdr" },
          { key: "Film effect", label: "aiWorkbench.faceSwapeStyleOptions.style.photoEffect.options.filmEffect" },
          { key: "Hard and soft light", label: "aiWorkbench.faceSwapeStyleOptions.style.photoEffect.options.hardSoftLight" },
          { key: "Long exposure effect", label: "aiWorkbench.faceSwapeStyleOptions.style.photoEffect.options.longExposure" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.specialEffect.label",
        key: "special_effect",
        options: [
          { key: "Low saturation", label: "aiWorkbench.faceSwapeStyleOptions.style.specialEffect.options.lowSaturation" },
          { key: "High contrast", label: "aiWorkbench.faceSwapeStyleOptions.style.specialEffect.options.highContrast" },
          { key: "High Dynamic Range (HDR)", label: "aiWorkbench.faceSwapeStyleOptions.style.specialEffect.options.hdr" },
          { key: "Duotone effect", label: "aiWorkbench.faceSwapeStyleOptions.style.specialEffect.options.duotone" },
          { key: "Fluorescent/Neon style", label: "aiWorkbench.faceSwapeStyleOptions.style.specialEffect.options.fluorescent" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeStyleOptions.style.postProcessingStyle.label",
        key: "post_processing_style",
        options: [
          { key: "Filter (vintage, B&W, film)", label: "aiWorkbench.faceSwapeStyleOptions.style.postProcessingStyle.options.filter" },
          { key: "Sharpening", label: "aiWorkbench.faceSwapeStyleOptions.style.postProcessingStyle.options.sharpening" },
          { key: "Denoise", label: "aiWorkbench.faceSwapeStyleOptions.style.postProcessingStyle.options.denoise" },
          { key: "Color correction", label: "aiWorkbench.faceSwapeStyleOptions.style.postProcessingStyle.options.colorCorrection" },
          { key: "Film grain", label: "aiWorkbench.faceSwapeStyleOptions.style.postProcessingStyle.options.filmGrain" }
        ]
      }
    ]
  },
];

export default styleOptions;